import React, { CSSProperties } from 'react';
import './index.module.less';

interface IProps {
  item: any;
  onSelect: (item: any, isSearch?: boolean) => void;
  selectItem: any;
  style?: CSSProperties;
}

const Item = (props: IProps) => {
  const { item, onSelect, selectItem, style = {} } = props;
  const { uniqueId, title, address } = item;

  const select = () => {
    onSelect && onSelect(item);
  };
  const isSelect = selectItem && selectItem.uniqueId === uniqueId;
  const distance =
    item.distance &&
    (item.distance >= 1000
      ? (item.distance / 1000).toFixed(2) + 'km'
      : item.distance.toFixed(2) + 'm');
  return (
    <div styleName="item" onClick={select} style={style}>
      <div styleName="item-name" className="flex">
        <span className="els-maxtwo" styleName="item-name-text">{title || ''}</span>
        {isSelect ? (
          <i className="iconfont icon-chenggong" styleName="icon-checked" />
        ) : null}
      </div>
      <div className="els-maxtwo" styleName="item-address">
        {item.distance > 0 ? (
          <span styleName="item-name-distance">{distance}｜</span>
        ) : null}
        {address || title || ''}
      </div>
    </div>
  );
};

export default Item;
